import React, { useEffect, useState } from "react";
import api from "../lib/api";
import Layout from "../components/Layout";
import { Send, Trash2, MessageSquare, ChevronDown, ChevronUp } from "lucide-react";
import { toast } from "sonner";

const today = () => new Date().toISOString().slice(0, 10);
const nowTime = () => new Date().toTimeString().slice(0, 5);
const inputCls = "w-full px-3 py-2 border border-[#E4E4E7] text-sm outline-none focus:border-[#002FA7]";

const Pesan = () => {
  const [employees, setEmployees] = useState([]);
  const [list, setList] = useState([]);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [target, setTarget] = useState("all");
  const [niks, setNiks] = useState([]);
  const [startDate, setStartDate] = useState(today());
  const [startTime, setStartTime] = useState(nowTime());
  const [endDate, setEndDate] = useState(today());
  const [endTime, setEndTime] = useState("23:59");
  const [sending, setSending] = useState(false);
  const [expandId, setExpandId] = useState("");
  const [confirmDel, setConfirmDel] = useState(null);

  const load = () => {
    api.get("/pesan").then((r) => setList(r.data || [])).catch(() => {});
    api.get("/pesan/employees").then((r) => setEmployees(r.data || [])).catch((e) => toast.error(e?.response?.data?.detail || "Gagal memuat karyawan"));
  };
  useEffect(() => { load(); }, []);

  const toggleNik = (nik) => setNiks((s) => (s.includes(nik) ? s.filter((x) => x !== nik) : [...s, nik]));

  const send = async () => {
    setSending(true);
    try {
      const { data: created } = await api.post("/pesan", {
        title, body, target, niks,
        start_at: `${startDate}T${startTime}`, end_at: `${endDate}T${endTime}`,
      });
      if (created.push_count !== null && created.push_count !== undefined) {
        toast.success(`Pesan aktif — notifikasi terkirim ke ${created.push_count} perangkat, popup muncul di aplikasi absensi`);
      } else {
        toast.success("Pesan terjadwal — notifikasi & popup akan dikirim saat jadwal mulai");
      }
      setTitle(""); setBody(""); setTarget("all"); setNiks([]);
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gagal mengirim pesan");
    } finally {
      setSending(false);
    }
  };

  const remove = async () => {
    try {
      await api.delete(`/pesan/${confirmDel.id}`);
      toast.success("Pesan dihapus");
      setConfirmDel(null);
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gagal menghapus");
    }
  };

  const fmtAt = (s) => (s || "").replace("T", " · ");

  return (
    <Layout>
      <div className="mb-6">
        <div className="label-cap mb-2">Komunikasi Internal</div>
        <h1 className="font-heading text-2xl sm:text-3xl md:text-4xl font-black tracking-tight">Pesan Karyawan</h1>
        <p className="text-xs text-[#52525B] mt-1">Pesan muncul sebagai pop up di aplikasi absensi (HadirApp) sesuai jadwal tampil.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white border border-[#E4E4E7]">
          <div className="px-4 py-3 border-b border-[#E4E4E7] flex items-center gap-2">
            <MessageSquare size={14} className="text-[#002FA7]" />
            <span className="label-cap">Buat Pesan</span>
          </div>
          <div className="p-4 space-y-4">
            <div>
              <div className="label-cap text-[10px] mb-1">Judul</div>
              <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="cth: Briefing pagi" data-testid="pesan-title" className={inputCls} />
            </div>
            <div>
              <div className="label-cap text-[10px] mb-1">Isi Pesan</div>
              <textarea value={body} onChange={(e) => setBody(e.target.value)} rows={4} placeholder="Tulis pesan untuk karyawan…" data-testid="pesan-body" className={inputCls} />
            </div>
            <div>
              <div className="label-cap text-[10px] mb-1">Tujuan</div>
              <div className="flex gap-4 mb-2">
                <label className="flex items-center gap-1.5 text-sm cursor-pointer">
                  <input type="radio" checked={target === "all"} onChange={() => setTarget("all")} data-testid="pesan-target-all" className="accent-[#002FA7]" /> Semua karyawan
                </label>
                <label className="flex items-center gap-1.5 text-sm cursor-pointer">
                  <input type="radio" checked={target === "nik"} onChange={() => setTarget("nik")} data-testid="pesan-target-nik" className="accent-[#002FA7]" /> Pilih karyawan
                </label>
              </div>
              {target === "nik" && (
                <div data-testid="pesan-employee-list" className="border border-[#E4E4E7] bg-[#FAFAFA] max-h-44 overflow-y-auto divide-y divide-[#E4E4E7]/60">
                  {employees.map((e) => (
                    <label key={e.nik} className="flex items-center gap-2 px-3 py-1.5 cursor-pointer text-sm">
                      <input type="checkbox" checked={niks.includes(e.nik)} onChange={() => toggleNik(e.nik)} data-testid={`pesan-emp-${e.nik}`} className="w-3.5 h-3.5 accent-[#002FA7]" />
                      <span className="flex-1">{e.name}</span>
                      <span className="font-mono text-[10px] text-[#A1A1AA]">{e.nik}</span>
                    </label>
                  ))}
                  {employees.length === 0 && <div className="px-3 py-3 text-xs text-[#52525B]">Tidak ada data karyawan absensi.</div>}
                </div>
              )}
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <div className="label-cap text-[10px] mb-1">Tampil Mulai</div>
                <div className="flex gap-1.5">
                  <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} data-testid="pesan-start-date" className={inputCls + " font-mono text-xs"} />
                  <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} data-testid="pesan-start-time" className={inputCls + " font-mono text-xs w-28"} />
                </div>
              </div>
              <div>
                <div className="label-cap text-[10px] mb-1">Sampai</div>
                <div className="flex gap-1.5">
                  <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} data-testid="pesan-end-date" className={inputCls + " font-mono text-xs"} />
                  <input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} data-testid="pesan-end-time" className={inputCls + " font-mono text-xs w-28"} />
                </div>
              </div>
            </div>
            <button onClick={send} disabled={sending} data-testid="pesan-send" className="w-full bg-[#002FA7] text-white text-xs font-bold uppercase tracking-wider py-3 flex items-center justify-center gap-2 hover:bg-[#00238a] disabled:opacity-60">
              <Send size={14} /> {sending ? "Mengirim…" : "Kirim / Jadwalkan Pesan"}
            </button>
          </div>
        </div>

        <div className="bg-white border border-[#E4E4E7]">
          <div className="px-4 py-3 border-b border-[#E4E4E7]"><span className="label-cap">Pesan Terkirim ({list.length})</span></div>
          <div className="divide-y divide-[#E4E4E7]/70 max-h-[560px] overflow-y-auto" data-testid="pesan-list">
            {list.length === 0 && <div className="p-6 text-sm text-[#52525B]">Belum ada pesan.</div>}
            {list.map((m) => (
              <div key={m.id} className="px-4 py-3" data-testid={`pesan-item-${m.id}`}>
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <div className="font-bold text-sm">{m.title}</div>
                    <div className="text-xs text-[#52525B] whitespace-pre-wrap line-clamp-2">{m.body}</div>
                    <div className="text-[10px] text-[#A1A1AA] font-mono mt-1">{fmtAt(m.start_at)} → {fmtAt(m.end_at)}</div>
                    <div className="text-[10px] text-[#52525B] mt-0.5">
                      {m.target === "all" ? "Semua karyawan" : `${(m.niks || []).length} karyawan dipilih`} · dibaca <span className="font-bold">{m.read_count}/{m.target_count}</span>
                      {m.read_count > 0 && (
                        <button onClick={() => setExpandId(expandId === m.id ? "" : m.id)} data-testid={`pesan-expand-${m.id}`} className="ml-2 text-[#002FA7] font-bold inline-flex items-center gap-0.5">
                          {expandId === m.id ? <>tutup <ChevronUp size={10} /></> : <>lihat <ChevronDown size={10} /></>}
                        </button>
                      )}
                    </div>
                    {expandId === m.id && (
                      <div className="mt-1.5 border border-[#E4E4E7] bg-[#FAFAFA] px-2 py-1.5 text-[10px] space-y-0.5">
                        {(m.reads || []).map((r, i) => (
                          <div key={i} className="flex justify-between gap-2"><span>{r.name || r.nik}</span><span className="font-mono text-[#A1A1AA]">{(r.at || "").slice(0, 16).replace("T", " ")}</span></div>
                        ))}
                      </div>
                    )}
                  </div>
                  <button onClick={() => setConfirmDel(m)} data-testid={`pesan-delete-${m.id}`} className="p-1.5 border border-[#E4E4E7] text-[#DC2626] hover:bg-[#FEF2F2]"><Trash2 size={13} /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {confirmDel && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50" onClick={() => setConfirmDel(null)}>
          <div onClick={(e) => e.stopPropagation()} className="bg-white border border-[#E4E4E7] max-w-sm w-full p-6">
            <h3 className="font-heading text-lg font-bold mb-2">Hapus Pesan?</h3>
            <p className="text-sm text-[#52525B] mb-6">"{confirmDel.title}" akan dihapus dan tidak lagi muncul di aplikasi absensi.</p>
            <div className="flex justify-end gap-2">
              <button onClick={() => setConfirmDel(null)} className="px-4 py-2 text-xs font-bold uppercase border border-[#E4E4E7]">Batal</button>
              <button onClick={remove} data-testid="pesan-confirm-delete" className="px-4 py-2 text-xs font-bold uppercase bg-[#DC2626] text-white">Hapus</button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default Pesan;
